/**
 * Prefer a small default chart series set that works across product lines.
 * Each group is tried in order; the first key present in `available` wins.
 */
const DEFAULT_HISTORY_KEY_GROUPS: string[][] = [
  ['pv_w', 'pv_total_p', 'pv_dc_p', 'dc_pv_w', 'solar'],
  ['load_w', 'load_p', 'consumption'],
  ['bat_w', 'pdu_p', 'battery', 'battery_power'],
  ['bat_soc', 'pdu_soc', 'soc', 'system_soc'],
  ['grid_w', 'grid_p', 'grid', 'grid_power'],
]

export function pickDefaultHistoryKeys(available: Iterable<string>): string[] {
  const set = available instanceof Set ? available : new Set(available)
  const picked: string[] = []
  for (const group of DEFAULT_HISTORY_KEY_GROUPS) {
    const hit = group.find((k) => set.has(k))
    if (hit) picked.push(hit)
  }
  return picked
}

/** Initial defaults before we know which keys Timestream returned. */
export function initialHistoryKeysForProductLine(productLine?: string | null): string[] {
  if (productLine === 'cabinet' || productLine === 'container') {
    return ['pv_total_p', 'load_p', 'pdu_p', 'pdu_soc', 'grid_p']
  }
  // sanctuary / peak / vault / unknown — Lion Smart day-view defaults
  return ['pv_w', 'load_w', 'bat_w', 'bat_soc', 'grid_w']
}
